import { Component, OnInit } from "@angular/core";
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { HttpKioskService } from "../../../http-kiosk.service";
import { catchError } from "rxjs/operators";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { KioskDto } from "../../../dto";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "src/app/service/auth.service";
import { environment } from "src/environments/environment";

@Component({
	selector: 'app-view-kiosk',
	templateUrl: './view-kiosk.component.html',
	styleUrls: ['./view-kiosk.component.scss']
})
export class ViewKioskComponent implements OnInit {
	kioskId: number;
	kiosk: KioskDto;
	back = faArrowLeft;

	activeTab: string = 'nav-info';
	env = environment;

	constructor(private location: Location, 
		private activeRoute: ActivatedRoute, 
		private httpService: HttpKioskService,
		private spinner: NgxSpinnerService,
		private authService: AuthService,
		private toastService: AppToastService) {}

	ngOnInit(): void {
		this.fetchKiosk();
	}

	public fetchKiosk() {
		this.activeRoute.paramMap.subscribe(map => this.kioskId = +map.get('kioskId'));
		this.spinner.show();
		this.httpService.getKiosk(this.kioskId)
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error fetching kiosk', error);
				this.toastService.showDanger({ content: 'Failed to fetch kiosk: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(data => {
			this.spinner.hide();
			if (!data.responseStatus) {
				this.toastService.showDanger({ content: 'Failed to fetch kiosk: ' + data.responseStatusMessage });
				return;
			}
			this.kiosk = data;
		});
	}

	activateTab($event) {
		const tabButtons = document.getElementsByName("tab-nav") as NodeListOf<HTMLElement>;
		var controlTarget;
		tabButtons.forEach(item => {
			item.className = 'nav-link';
			if (item.id === $event.target.id) {
				item.className = 'nav-link active';
				controlTarget = document.getElementById($event.target.id).getAttribute('aria-controls');
			}
		});

		const tabContent = document.getElementsByName("tab-content") as NodeListOf<HTMLElement>;
		tabContent.forEach(item => {
			item.className = 'tab-pane fade';
			if (item.id === controlTarget) {
				this.activeTab = controlTarget;
				item.className = 'tab-pane fade show active';
			}
		});
	}

	isTabActive(id: string) {
		return id === this.activeTab;
	}

	get kioskDetails(): string {
		if (!this.kiosk) {
			return '';
		}
		if (this.kiosk.name === null) {
			return this.kiosk.deviceRef;
		}
		if (!this.kiosk.location) {
			return this.kiosk.name	
		}
		return this.kiosk.name + ' - ' + this.kiosk.location.name;
	}

	showTab(action: string) {
		return this.authService.hasAnyRole(environment.allowedActions.filter(item => item.action === action)[0].role);
	}

	goBack(): void {
		this.location.back()
	}

}